<div class="track-my-location-container px-3 static-mobile-page">
  <div class="track-my-location">

    <div class="header col-12 md:col-12 lg:col-12 sm:col-12 p-0 grid justify-content-between">

      <div class="col-6 md:col-12 lg:col-6 sm:col-12 p-0" style="width: 125px; margin-top: 4px;"
        *ngIf="showLanguageDropdown">
        <p-dropdown [options]="langaugeOptions" appendTo="body" [(ngModel)]="selectedLangauge"
        (onChange)="getPrivacyPolicy()">
        </p-dropdown>
      </div>
    </div>
    <div class="  col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>

    <div *ngIf="privacyPolicyData" class=" col-12 md:col-12 lg:col-12">
      <div [innerHTML]="privacyPolicyData | keepHtml"></div>
    </div>



  </div>
</div>

